import { useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { MdDragIndicator } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { editNodeValue } from '../redux/vansh-reducer';

function TextUpdaterNode({ id, data, isConnectable }) {
  const { vanshNodes } = useSelector(state => state.vansh);
  const dispatch = useDispatch();
  const onChange = useCallback(
    evt => {
      dispatch(editNodeValue({ id, value: evt.target.value }));
    },
    [dispatch, id]
  );

  const myVal = vanshNodes.find(el => el.id === id);

  return (
    <div className="text-updater-node">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <textarea
        id="text"
        name="text"
        onChange={onChange}
        value={myVal && (myVal.data.value || data.value)}
        className="nodrag"
        placeholder="नाम लिखें"
        title="नेम बॉक्स डिलीट करने के लिए डबल क्लिक करें"
      />
      <MdDragIndicator size={22} className="icon" />

      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={isConnectable}
      />
    </div>
  );
}

export default TextUpdaterNode;
